import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

/** Resolve a product/media image src stored by the backend.
 *  - Absolute URLs (http(s)://, data:) are returned unchanged.
 *  - `/api/media/...` paths are prefixed with BACKEND_URL so <img src> works.
 *  - Anything else is returned unchanged (e.g. emoji placeholders handled by callers).
 */
export const resolveImageSrc = (src) => {
  if (!src || typeof src !== "string") return src;
  if (src.startsWith("http://") || src.startsWith("https://") || src.startsWith("data:")) return src;
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return src;
};

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ibloom_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const sess = localStorage.getItem("ibloom_session");
  if (sess) config.headers["X-Session-ID"] = sess;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // optional: redirect to login on expired
    }
    return Promise.reject(err);
  }
);
